module.exports = __webpack_public_path__ + "img/root.2428725b.png";